import { render } from "./formbasic-input.vue?vue&type=template&id=506b73f1"
import script from "./formbasic-input.vue?vue&type=script&lang=js"
export * from "./formbasic-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__